import Dexie, { Table } from 'dexie';
import { PfkOrganization, PfkTitle } from './pre-filter-values-service';

export interface CacheType {
  id: string;
  lastUpdated: Date;
}
export interface CacheItem {
  id: string;
  typeId: string;
  page: number;
  value: string;
}

export class CacheDb extends Dexie {
  cacheTypes!: Table<CacheType, string>;
  cacheItems!: Table<CacheItem, string>;
  cacheTitles: Table<PfkTitle, string>;
  cacheOrganizations: Table<PfkOrganization, string>;

  constructor() {
    super('PIDataCache');
    this.version(3).stores({
      cacheTypes: 'id',
      cacheItems: 'id, typeId',
      cacheTitles: 'titleId, *titleWords',
      cacheOrganizations: 'organizationId, *nameWords'
    });
    this.on('populate', () => this.populate());
  }

  async populate() {
    if (await cacheDb.cacheTypes.count() === 0) {
      await cacheDb.cacheTypes.bulkAdd([
        { id: 'regions', lastUpdated: new Date(0) },
        { id: 'industries', lastUpdated: new Date(0) },
        { id: 'occupations', lastUpdated: new Date(0) },
        { id: 'titles', lastUpdated: new Date(0) },
        { id: 'organizations', lastUpdated: new Date(0) }
      ]);
    }
  }
}

export const cacheDb = new CacheDb();

cacheDb.cacheTitles.hook("creating", function (primKey, obj, trans) {
  if (typeof obj.title == 'string') obj.titleWords = getAllWords(obj.title);
});

cacheDb.cacheTitles.hook("updating", function (mods, primKey, obj, trans) {
  if (mods.hasOwnProperty("title")) {
    if (typeof obj.title == 'string') {
      return { titleWords: getAllWords(obj.title) };
    } else {
      return { titleWords: [] };
    }
  }
});

cacheDb.cacheOrganizations.hook("creating", function (primKey, obj, trans) {
  if (typeof obj.organizationName == 'string') obj.nameWords = getAllWords(obj.organizationName);
});

cacheDb.cacheOrganizations.hook("updating", function (mods, primKey, obj, trans) {
  if (mods.hasOwnProperty("title")) {
    if (typeof obj.organizationName == 'string') {
      return { nameWords: getAllWords(obj.organizationName) };
    } else {
      return { nameWords: [] };
    }
  }
});

function getAllWords(text) {
  /// <param name="text" type="String"></param>
  var allWordsIncludingDups = text.split(' ');
  var wordSet = allWordsIncludingDups.reduce(function (prev, current) {
    prev[current] = true;
    return prev;
  }, {});
  return Object.keys(wordSet);
}
